module.exports = __webpack_public_path__ + "static/assets/54a33fa1a2ed2fce5d999f77494c5ac3.svg";